// extracted by mini-css-extract-plugin
export var shake = "_13-0";